import { render, staticRenderFns } from "./TrBookIndexLink.vue?vue&type=template&id=b1f89946&scoped=true&"
import script from "./TrBookIndexLink.vue?vue&type=script&lang=js&"
export * from "./TrBookIndexLink.vue?vue&type=script&lang=js&"
import style0 from "./TrBookIndexLink.vue?vue&type=style&index=0&id=b1f89946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f89946",
  null
  
)

export default component.exports